/**
 * 파일명: privacyCollect.ko.js
 * 설명: 개인정보 수집 및 이용 동의문 (한국어) — 회원가입 시 동의를 받는 문서
 */
const privacyCollectKo = {
  title: "개인정보 수집 및 이용 동의",
  intro: [
    {
      type: "p",
      text: "(주)리브테크놀로지(이하 “회사”)는 all Place 회원 가입 및 서비스 제공을 위하여 아래와 같이 개인정보를 수집·이용합니다. 내용을 확인하신 후 동의 여부를 결정해 주세요.",
    },
  ],
  sections: [
    {
      title: "1. 수집하는 개인정보 항목",
      blocks: [
        { type: "p", text: "[필수] 회원 가입 시 입력하는 정보" },
        {
          type: "ul",
          items: ["이메일 주소", "회사명", "사용자 이름", "비밀번호"],
        },
        {
          type: "p",
          text: "서비스 이용 과정에서 자동으로 생성·수집되는 접속 기록, 쿠키 등에 관한 사항은 개인정보처리방침에서 확인하실 수 있습니다.",
        },
      ],
    },
    {
      title: "2. 개인정보의 수집 및 이용 목적",
      blocks: [
        {
          type: "ul",
          items: [
            "회원 가입 의사 확인, 회원 식별 및 본인 확인",
            "회의실 예약, 자율좌석, 화상회의 등 서비스의 제공 및 운영",
            "소속 회사 단위의 이용 권한 관리 및 관리자 승인 처리",
            "고객 문의 대응 및 서비스 관련 공지사항 전달",
            "부정 이용 방지 및 서비스 이용 현황 통계 분석",
          ],
        },
      ],
    },
    {
      title: "3. 개인정보의 보유 및 이용 기간",
      blocks: [
        {
          type: "p",
          text: "회원 탈퇴 시 또는 위 수집·이용 목적이 달성된 때까지 보유·이용하며, 그 이후에는 지체 없이 파기합니다. 다만 관계 법령에 따라 보존 의무가 있는 경우에는 해당 기간까지 보관합니다.",
        },
        {
          type: "ul",
          items: [
            "소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (「전자상거래 등에서의 소비자보호에 관한 법률」)",
            "대금결제 및 재화 등의 공급에 관한 기록 : 5년 (「전자상거래 등에서의 소비자보호에 관한 법률」)",
            "계약 또는 청약철회 등에 관한 기록 : 5년 (「전자상거래 등에서의 소비자보호에 관한 법률」)",
            "표시·광고에 관한 기록 : 6개월 (「전자상거래 등에서의 소비자보호에 관한 법률」)",
          ],
        },
      ],
    },
    {
      title: "4. 동의를 거부할 권리 및 거부 시 불이익",
      blocks: [
        {
          type: "p",
          text: "귀하는 개인정보 수집·이용에 대한 동의를 거부할 권리가 있습니다. 다만 위 항목은 회원 가입 및 서비스 제공에 반드시 필요한 최소한의 정보이므로, 동의를 거부하시는 경우 회원 가입이 제한됩니다.",
        },
      ],
    },
    {
      title: "5. 그 밖의 사항",
      blocks: [
        {
          type: "p",
          text: "개인정보의 제3자 제공, 파기 절차, 정보주체의 권리 행사 방법 등 개인정보 처리에 관한 자세한 내용은 개인정보처리방침에서 확인하실 수 있습니다.",
        },
      ],
    },
  ],
};

export default privacyCollectKo;
